import { render, staticRenderFns } from "./FaceLogin.vue?vue&type=template&id=eb21f562&scoped=true&"
import script from "./FaceLogin.vue?vue&type=script&lang=js&"
export * from "./FaceLogin.vue?vue&type=script&lang=js&"
import style0 from "./FaceLogin.vue?vue&type=style&index=0&id=eb21f562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb21f562",
  null
  
)

export default component.exports